import qrcode from 'qrcode-generator'

// ── drawQR ────────────────────────────────────────────────────────────────────
// Draws a scannable QR onto a canvas 2d context: a white rounded panel (its own
// quiet zone) with dark modules — the standard high-contrast look that scanners
// need, and that reads on our dark share cards. `size` is the outer panel px.
// Used by the downloadable share cards so a screenshot/repost carries a way back.
export function drawQR(ctx, text, x, y, size, { pad = Math.round(size * 0.1), radius = Math.round(size * 0.12), fg = '#07070f' } = {}) {
  if (!text) return
  let qr
  try {
    qr = qrcode(0, 'M')            // type 0 = auto-fit, error-correction M
    qr.addData(String(text))
    qr.make()
  } catch { return }              // never break a card render over a QR
  const count = qr.getModuleCount()
  ctx.save()
  ctx.fillStyle = '#ffffff'
  if (ctx.roundRect) { ctx.beginPath(); ctx.roundRect(x, y, size, size, radius); ctx.fill() }
  else ctx.fillRect(x, y, size, size)
  const inner = size - pad * 2
  const cell = inner / count
  ctx.fillStyle = fg
  for (let r = 0; r < count; r++) {
    for (let c = 0; c < count; c++) {
      if (qr.isDark(r, c)) ctx.fillRect(x + pad + c * cell, y + pad + r * cell, Math.ceil(cell), Math.ceil(cell))
    }
  }
  ctx.restore()
}
